import { useEffect, useState } from "react";
import Header from "./Header";
import History from "./History";
import {  FileText } from "lucide-react";
import { LabService } from "../../services/api/LaborderService/lab.service";
import LabOrderListingSidebar from "./Sidebar";
import { LabtestOrderDetails, LabtestOrderStatus } from "../../services/api/LaborderService/types";
import LabOrderDetailsView from "./OrderDetails";
import toast from "react-hot-toast";

interface UploadedFile {
    id: number;
    file: File;
    name: string;
    size: number;
    type: string;
    url: string;
    uploadedAt: string;
}

const LabMain = () => {
  const [activeTab, setTab] = useState<"new" | "history">("new");
  const [uploadedFile, setUploadedFile] = useState<UploadedFile[] | []>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [labtests, setLabtests] = useState<LabtestOrderDetails[]>([]);
  const [selectedOrder, setSelectedOrder] = useState<LabtestOrderDetails | null>(null);
  const [orderStatus, setOrderStatus] = useState<LabtestOrderStatus>(LabtestOrderStatus.MOVED_TO_LAB);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalCount: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  // If user is on "history" tab, show History component only
  if (activeTab === "history") {
    return (
      <div className="bg-white">
        <Header activeTab={activeTab} onTabChange={setTab} />
        <History />
      </div>
    );
  }

  const fetchOrders = async () => {
    setIsLoading(true);
    try {
      const response = await LabService.getLabOrdersListing(pagination.page, pagination.pageSize, '', orderStatus, searchText)
      if (response.success) {
        setLabtests(response.data?.labtests)
        setPagination({
          page: response.data?.currentPage,
          pageSize: response.data?.pageSize,
          totalPages: response.data?.totalPages,
          totalCount: response.data?.totalItems,
        })
        setSelectedOrder(response.data.labtests[0]);
      }
    } catch (error) {
      toast.error("Error in feching labtests");
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchOrders();
  }, [pagination.page]);

  const handleOrderSelect = (order: LabtestOrderDetails) => {
    setSelectedOrder(order)
  }

  const handleSubmitReport= async (id: number) => {
    try {
      setIsSubmitting(true);
      const files=uploadedFile.map((file)=>file.file);
      const response = await LabService.updateLabOrder(id, files)
      if (response.success) {
        toast.success("Report submitted successfully");
        setUploadedFile([]);
        fetchOrders();
      }
    } catch (error) {
      toast.error("Error in submitting report")
    }
    finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="w-full h-full overflow-y-auto hiddenScrollbar">
      <div className=" w-full h-[5%] pr-4 pb-4 flex items-center justify-between rounded-t-md border-b border-gray-400/30">
        <div>
          <button className="px-3 h-full flex items-center gap-2 text-gray-600 font-semibold border-gray-700">
            <FileText size={18} />
            Labtests - {pagination.totalCount}
          </button>
        </div>
        <div>
          <button className="px-3 h-full flex items-center gap-2 text-green-600 font-semibold border-green-700">
            <FileText size={18} />
            Tests-history
          </button>
        </div>
      </div>
      <div className=" w-full h-[95%] flex justify-start overflow-y-auto hiddenScrollbar">
        <LabOrderListingSidebar
          orders={labtests}
          selectedOrder={selectedOrder}
          onOrderSelect={handleOrderSelect}
          isLoading={isLoading}
          pagination={{
            currentPage: pagination.page,
            totalPages: pagination.totalPages,
          }}
          onPageChange={(page) => setPagination({ ...pagination, page })}
        />

        <LabOrderDetailsView
          selectedOrder={selectedOrder}
          orderLoading={isLoading}
          uploadedFile={uploadedFile}
          setUploadedFile={setUploadedFile}
          submitting={isSubmitting}
          handleSubmitReport={handleSubmitReport}
        />
      </div>
    </div>
  );
};

export default LabMain;
